import { cfgBrand } from '@infinitro/config';
import { Verbiage, t } from '@infinitro/content';
import { get } from 'svelte/store';
export const humanizeAuthError = (e) => {
    const translate = get(t);
    const brand = cfgBrand();
    const raw = String(e ?? '');
    // UserBan error
    if (/AdminBan|BANNED/i.test(raw)) {
        return translate(Verbiage.user_banned).replace('[BRAND]', brand);
    }
    return raw;
};
